<div class="card min-w-[500px]">
  <!-- Card Header -->
  <div class="px-4 py-3 border-b border-gray-200 dark:border-gray-700">
    <span class="text-lg font-semibold text-gray-900 dark:text-white">
      {{ editMarketingItem ? 'Edit Marketing Item' : 'Insert Marketing Item' }}
    </span>
  </div>

  <!-- Card Body -->
  <div class="p-4">
    <form
      class="space-y-4"
      [formGroup]="marketingForm"
      (ngSubmit)="formSubmit()"
      *ngIf="marketingForm"
    >
      <div class="marketing-row">
        <label kendoLabel for="reportDate">Report Date:</label>
        <kendo-datepicker id="reportDate" formControlName="reportDate"></kendo-datepicker>
      </div>

      <div class="marketing-row">
        <label kendoLabel for="marketingTypeId">Marketing Type:</label>
        <kendo-dropdownlist
          [data]="marketingTypes"
          id="marketingTypeId"
          formControlName="marketingTypeId"
          textField="marketingTypeName"
          valueField="marketingTypeId"
          [valuePrimitive]="true"
        ></kendo-dropdownlist>
      </div>

      <div class="marketing-row">
        <label kendoLabel for="marketingStatusTypeId">Marketing Status Type:</label>
        <kendo-dropdownlist
          id="marketingStatusTypeId"
          [data]="marketingStatusTypes"
          formControlName="marketingStatusTypeId"
          textField="marketingStatusTypeName"
          valueField="marketingStatusTypeId"
          [valuePrimitive]="true"
          [disabled]="!canUpdateStatus"
        ></kendo-dropdownlist>
      </div>

      <div class="marketing-row">
        <label kendoLabel for="submitDate">Submit Date:</label>
        <kendo-datepicker id="submitDate" formControlName="submitDate"></kendo-datepicker>
      </div>

      <div class="marketing-row">
        <label kendoLabel for="submittedBy">Submitted By:</label>
        <input kendoTextBox id="submittedBy" type="text" formControlName="submittedBy" />
      </div>

      <div class="marketing-row">
        <label kendoLabel for="approveDateAdvisor">Approve Date Advisor:</label>
        <kendo-datepicker id="approveDateAdvisor" formControlName="approveDateAdvisor"></kendo-datepicker>
      </div>

      <div class="marketing-row">
        <label kendoLabel for="approvedByAdvisorCco">Approved By Advisor CCO:</label>
        <input id="approvedByAdvisorCco" kendoTextBox type="text" formControlName="approvedByAdvisorCco" />
      </div>

      <div class="marketing-row">
        <label kendoLabel for="approvedByFundCco">Approved By Fund CCO:</label>
        <input id="approvedByFundCco" kendoTextBox type="text" formControlName="approvedByFundCco" />
      </div>

      <div class="marketing-row">
        <label kendoLabel for="approveDateFundCco">Approve Date Fund CCO:</label>
        <kendo-datepicker id="approveDateFundCco" formControlName="approveDateFundCco"></kendo-datepicker>
      </div>

      <div class="marketing-row">
        <label kendoLabel for="approvedByFundDist">Approved By Fund Dist:</label>
        <input id="approvedByFundDist" kendoTextBox type="text" formControlName="approvedByFundDist" />
      </div>

      <div class="marketing-row">
        <label kendoLabel for="approveDateFundDist">Approve Date Fund Dist:</label>
        <kendo-datepicker id="approveDateFundDist" formControlName="approveDateFundDist"></kendo-datepicker>
      </div>

      <div class="marketing-row">
        <label kendoLabel for="description">Description:</label>
        <textarea id="description" kendoTextArea formControlName="description"></textarea>
      </div>

      <div class="marketing-row">
        <label kendoLabel for="assignedTo">Assigned To:</label>
        <kendo-dropdownlist
          id="assignedTo"
          [data]="userList"
          textField="email"
          valueField="email"
          formControlName="assignedTo"
          [valuePrimitive]="true"
        ></kendo-dropdownlist>
      </div>

      <div class="marketing-row">
        <label kendoLabel for="marketingEntityTypeId">Entity:</label>
        <kendo-dropdownlist
          id="marketingEntityTypeId"
          [data]="marketingEntityTypes"
          formControlName="marketingEntityTypeId"
          textField="marketingEntityTypeName"
          valueField="marketingEntityTypeId"
          [valuePrimitive]="true"
        ></kendo-dropdownlist>
      </div>

      <div class="marketing-row">
        <label kendoLabel for="performanceDataIncluded">Performance Data Included:</label>
        <input id="performanceDataIncluded" kendoCheckBox class="cb" type="checkbox" formControlName="performanceDataIncluded" />
      </div>

      <div class="marketing-row">
        <label kendoLabel for="marketingDistributionMethodTypeId">Distribution Method:</label>
        <kendo-dropdownlist
          id="marketingDistributionMethodTypeId"
          [data]="marketingDistributionMethodTypes"
          formControlName="marketingDistributionMethodTypeId"
          textField="marketingDistributionMethodTypeName"
          valueField="marketingDistributionMethodTypeId"
          [valuePrimitive]="true"
        ></kendo-dropdownlist>
      </div>

      <div class="marketing-row">
        <label kendoLabel for="marketingDistributionQuantityTypeId">Distribution Quantity</label>
        <kendo-dropdownlist
          id="marketingDistributionQuantityTypeId"
          [data]="marketingDistributionQuantityTypes"
          formControlName="marketingDistributionQuantityTypeId"
          textField="marketingDistributionQuantityTypeName"
          valueField="marketingDistributionQuantityTypeId"
          [valuePrimitive]="true"
        ></kendo-dropdownlist>
      </div>

      <div class="marketing-row">
        <label kendoLabel for="submittedToNasd">Submitted To NASD:</label>
        <kendo-datepicker id="submittedToNasd" formControlName="submittedToNasd"></kendo-datepicker>
      </div>

      <div class="marketing-row">
        <label kendoLabel for="dateOfFirstUse">Date Of First Use:</label>
        <kendo-datepicker id="dateOfFirstUse" formControlName="dateOfFirstUse"></kendo-datepicker>
      </div>

      <div class="marketing-row">
        <button
          kendoButton
          primary="true"
          look="outline"
          type="submit"
          [disabled]="!marketingForm.valid"
          class="mt-4 px-6 py-2 border border-blue-500 text-blue-600 rounded hover:bg-blue-50 dark:border-blue-400 dark:text-blue-400 dark:hover:bg-blue-900"
        >
          {{ marketingEditItem ? 'Update' : 'Save' }}
        </button>
      </div>
    </form>
  </div>
</div>
